<template>
	<div class="modal fade" :id="modal.selector" tabindex="-1" role="dialog" aria-hidden="true">
		<div class="modal-dialog" role="document">
			<div class="modal-content">
				<loading :active="reloading">
					<img :src="$env.ROOT + '/img/loading.gif'" width="55px" height="55px">
				</loading>
				<div class="modal-header">
					<div class="btn-toolbar pull-right" role="toolbar">
						<div class="btn-group" role="group" aria-label="...">
							<button type="button" class="close" @click="close">
								<span aria-hidden="true">&times;</span>
							</button>
						</div>
					</div>
					<h4>Pagos parciales</h4>
				</div>
				<div class="modal-body">
					<create
						ref="create"
						@close="display = false"
						@reload="reload"
						@calculate="calculate"
						:pending_payment="pending_payment"
						:display="display"
						:payment_methods="payment_methods"
						:order="order"
						:invoice="invoice"
						:user="user"
						:isAuth="isAuth">
					</create>
					<template v-if="partial_payments">
						<template v-if="partial_payments.length">
							<table class="table table-hover table-striped table-condensed">
								<thead>
									<tr>
										<th>Importe</th>
										<th>Método de pago</th>
										<th></th>
									</tr>
								</thead>
								<tbody>
									<template v-for="partial in partial_payments">
										<edit
											ref="edit"
											@editModeOn="displayEdit = true"
											@editModeoff="displayEdit = false"
											@reload="reload"
											@calculate="calculate"
											:pending_payment="pending_payment"
											:displayEdit="displayEdit"
											:partial="partial"
											:payment_methods="payment_methods"
											:order="order"
											:invoice="invoice"
											:user="user"
											:isAuth="isAuth">
										</edit>
									</template>
								</tbody>
							</table>
						</template>
					</template>
					<table class="table table-hover table-striped table-condensed">
						<tbody>
							<tr>
								<td><h5><b>Total:</b></h5></td>
								<template v-if="order">
									<td class="text-right"><h5>{{ order.total }}</h5></td>
								</template>
								<template v-if="invoice">
									<td class="text-right"><h5>{{ invoice.total }}</h5></td>
								</template>
							</tr>
							<tr>
								<td><h5><b>Total pagos parciales:</b></h5></td>
								<td class="text-right"><h5>{{ total_partial_payments }}</h5></td>
							</tr>
							<tr :class="{ 'success' : pending_payment >= 0, 'danger' : pending_payment < 0 }">
								<td><h5><b>Pago pendiente:</b></h5></td>
								<td class="text-right"><h5>{{ pending_payment }}</h5></td>
							</tr>
						</tbody>
					</table>
				</div>
				<div class="modal-footer">
					<button v-if="!display && !displayEdit && pending_payment > 0" type="button" class="btn btn-success" @click="openCreateForm">Añadir</button>
					<button type="button" class="btn btn-default" @click="close">Cerrar</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import swal from 'sweetalert2'
	import Ladda from 'ladda'
	import VueElementLoading from 'vue-element-loading'
	import Create from '../views/Create'
	import Edit from '../views/Edit'

	export default {
		props: ['user', 'isAuth', 'order', 'invoice'],
		components: {
			'loading': VueElementLoading,
			'create': Create,
			'edit': Edit,
		},
		data () {
			return {
				modal: {
					selector: 'modal-partial-payments',
				},
				reloading: false,
				loading: false,
				display: false,
				displayEdit: false,

				payment_methods: null,

				partial_payments: null,

				total_partial_payments: null,
				pending_payment: null,

				currency: null,
			}
		},
		mounted() {
			var modal = $('#'+this.modal.selector)
			var that = this
			modal.on('hidden.bs.modal', function () {
				that.loading = false
				that.display = false
				that.displayEdit = false
				that.$refs.create.clearData()
				var edits = that.$refs.edit
				if(edits) {
					if(edits.length) {
						edits.forEach(function(edit) {
							edit.edit_mode = false
							edit.clearData()
						})
					}
				}
			})
		},
		watch: {
			'item.amount'() {
				this.item.amount = this.$options.filters.checkDecimals(this.item.amount)
			},
			'invoice.partial_payments'() {
				this.loadData()
				this.reloading = false
			},
			'order.partial_payments'() {
				this.loadData()
				this.reloading = false
			},
			display() {
				if(this.display) {
					this.displayEdit = true
				} else {
					this.displayEdit = false
				}
			}
		},
		methods: {
			open() {
				this.getPayMentMethods()
				this.loadData()
				var modal = $('#'+this.modal.selector)
				modal.modal('show')
			},
			close () {
				var modal = $('#'+this.modal.selector)
				modal.modal('hide')
			},
			init() {
				this.getPayMentMethods()
			},
			reload() {
				this.reloading = true
				this.$emit('reload')
			},
			calculate(partial = null) {
				var total_partial_payments = 0
				if(this.partial_payments) {
					if(this.partial_payments.length) {
						this.partial_payments.forEach(function(element) {
							if(partial) {
								if(partial.id) {
									if(element.id != partial.id) {
										total_partial_payments = total_partial_payments + parseFloat(element.amount)
									}
								} else {
									total_partial_payments = total_partial_payments + parseFloat(element.amount)
								}
							} else {
								total_partial_payments = total_partial_payments + parseFloat(element.amount)
							}
						})
					}

				}
				var amount = 0
				if(partial) {
					if(partial.amount) {
						amount = parseFloat(partial.amount)
					}
				}
				total_partial_payments = parseFloat(total_partial_payments) + amount
				this.total_partial_payments = total_partial_payments.toFixed(2)

				var total = 0
				if(this.order) {
					total = parseFloat(this.order.total)
				}
				if(this.invoice) {
					total = parseFloat(this.invoice.total)
				}
				this.pending_payment = parseFloat(total - total_partial_payments).toFixed(2)
			},
			loadData() {
				this.partial_payments = null
				if(this.order) {
					this.partial_payments = this.order.partial_payments
					this.total_partial_payments = this.order.total_partial_payments
					this.pending_payment = this.order.pending_payment
					this.currency = this.order.currency
				}
				if(this.invoice) {
					this.partial_payments = this.invoice.partial_payments
					this.total_partial_payments = this.invoice.total_partial_payments
					this.pending_payment = this.invoice.pending_payment
					this.currency = this.invoice.currency
				}
			},
			openCreateForm() {
				this.display = true
			},
			getPayMentMethods() {
				this.$http.get('admin/management/payment/methods')
				.then(response => {
					this.payment_methods = response.body
				}).catch(function(response) {
					console.log(response)
				})
			},
		},
	}
</script>


// WEBPACK FOOTER //
// src/components/management/partialPayments/layout/PartialPayments.vue